export * from './row-details-table';
